import { render, staticRenderFns } from "./produceRecord.pug?vue&type=template&id=08a0113a&scoped=true&lang=pug&"
import script from "./produceRecord.ts?vue&type=script&lang=ts&"
export * from "./produceRecord.ts?vue&type=script&lang=ts&"
import style0 from "./produceRecord.styl?vue&type=style&index=0&id=08a0113a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a0113a",
  null
  
)

export default component.exports